import request from "libs/request";

type Score = {
  evaluatePointCode: string
  name: "有趣" | "有用" | "无趣" | "无用"
}
type CommonLinks = {
  bizId: string
  content: string
  avatarType: number
}

export type IssueInfo = {
  contentType: 2 | 3 // 2点评帖、3动态贴
  title?: string
  content?: string
  imageUrl?: string[]
  score?: Score[]
  commonLinks?: CommonLinks[]
  relatedObjId?: number
  relatedObjType?: number
}

export type UserInfo = {
  address?: string
  area?: string
  birthday?: string
  city?: string
  cityCode?: string
  cuteNum?: string
  gender?: number // 性别 0：女 1：男
  headUrl?: string // 头像url
  identityType?: number // 账户类型(0:普通员工；1：运营马甲号)
  nickName?: string // 昵称
  phone?: string // 手机号
  province?: string // 省
  provinceCode?: string // 省code
  remoteControlCode?: string // 4位控车码
  userId?: string // 业务主键
  userName?: string // 用户名
}
/**
 * 上传图片
 */
 export function uploadImgService(file: File) {
   const form = new FormData();
   form.append("file", file);
  return request({
    method: 'post',
    // url: `${"http://appserver-view.test.internal.avatr.com:9080"}/file/v2/upload/1`,
    url: `${process.env.REACT_APP_DOMAIN}/file/v2/upload/1`,
    data: form
  })
}

// 发帖缓存：用于H5调用发帖作为服务端缓存
export function uploadIssueFiles(data: IssueInfo) {
 return request({
   method: 'post',
   url: `/api/evaluateContent/ugcTemporaryStorage`,
   data
 })
}

export function updateUserBaseInfo(data: UserInfo){
  return request({
    method: "post",
    url: `/api/app/user/updateUserBaseInfo`,
    data
  })
}

// 查询权益列表词典
export function getTreeByType(key: String){
  return request({
    method: "get",
    url: `boss/dict/treeByType/${key}`
  })
}

// 获取用户信息
export function getUserBaseInfo() {
  return request({
    url: `/api/app/user/queryUserBaseInfo`,
    method: 'get'
  })
}